/// <reference types="../../@types/post-robot" />
import postRobot from 'post-robot';

import { ThemeType } from 'shared/interfaces';

export const getParentTheme = async (): Promise<ThemeType> => {
    const theme = await postRobot.send(window.parent, 'GetTheme');

    return theme.data as ThemeType;
};
